"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchToLiveMode = exports.switchToTestMode = exports.getCurrentSession = exports.toggleMerchantSession = exports.isTestMode = exports.canEnableSessionSwitch = exports.sessionSwitcherEnabled = exports.canEnableTestSession = exports.checkTestSession = exports.getSessionCookies = void 0;

var _localStorage = _interopRequireDefault(require("local-storage"));

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

var _env = require("../constants/env");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getSessionCookies = function getSessionCookies() {
  var cookies = new _universalCookie["default"]();
  var authToken = cookies.get(_env.AUTH_TOKEN),
      merchantMID = cookies.get(_env.MERCHANT_MID),
      product = cookies.get(_env.PRODUCT),
      dashboardPreference = cookies.get(_env.DASHBOARD_PREFERENCE),
      testAuthToken = cookies.get(_env.TEST_AUTH_TOKEN),
      testMerchantMID = cookies.get(_env.TEST_MERCHANT_MID);
  return {
    authToken: authToken,
    merchantMID: merchantMID,
    product: product,
    dashboardPreference: dashboardPreference,
    testAuthToken: testAuthToken,
    testMerchantMID: testMerchantMID
  };
};

exports.getSessionCookies = getSessionCookies;

var checkTestSession = function checkTestSession() {
  var _getSessionCookies = getSessionCookies(),
      testAuthToken = _getSessionCookies.testAuthToken,
      testMerchantMID = _getSessionCookies.testMerchantMID,
      product = _getSessionCookies.product,
      dashboardPreference = _getSessionCookies.dashboardPreference; // only those merchants are authenticated whose dashboardPreference is new Dashboard


  return !!testAuthToken && !!testMerchantMID && !!product && !!dashboardPreference && dashboardPreference === 'one_dashboard';
};

exports.checkTestSession = checkTestSession;

var canEnableTestSession = function canEnableTestSession() {
  var _getSessionCookies2 = getSessionCookies(),
      testAuthToken = _getSessionCookies2.testAuthToken,
      testMerchantMID = _getSessionCookies2.testMerchantMID,
      product = _getSessionCookies2.product,
      dashboardPreference = _getSessionCookies2.dashboardPreference;

  return (!testAuthToken || !testMerchantMID) && !!product && !!dashboardPreference && dashboardPreference === 'one_dashboard' && _localStorage["default"].get('currentSession') !== _env.MERCHANT_SESSION.TEST;
};

exports.canEnableTestSession = canEnableTestSession;

var sessionSwitcherEnabled = function sessionSwitcherEnabled() {
  return process.env.CURRENT_ENV !== _env.ENV.UAT && checkTestSession();
};

exports.sessionSwitcherEnabled = sessionSwitcherEnabled;

var canEnableSessionSwitch = function canEnableSessionSwitch() {
  return process.env.CURRENT_ENV !== _env.ENV.UAT && canEnableTestSession();
};

exports.canEnableSessionSwitch = canEnableSessionSwitch;

var isTestMode = sessionSwitcherEnabled() && _localStorage["default"].get('currentSession') === _env.MERCHANT_SESSION.TEST;

exports.isTestMode = isTestMode;

var toggleMerchantSession = function toggleMerchantSession(session) {
  _localStorage["default"].set('currentSession', session);

  window.location.reload();
};

exports.toggleMerchantSession = toggleMerchantSession;

var getCurrentSession = function getCurrentSession() {
  return _localStorage["default"].get('currentSession');
};

exports.getCurrentSession = getCurrentSession;

var switchToTestMode = function switchToTestMode() {
  toggleMerchantSession(_env.MERCHANT_SESSION.TEST);
};

exports.switchToTestMode = switchToTestMode;

var switchToLiveMode = function switchToLiveMode() {
  toggleMerchantSession(_env.MERCHANT_SESSION.LIVE);
};

exports.switchToLiveMode = switchToLiveMode;